import axiosInstance from "../../utils/axiosInstance";
import { getClientId } from "../../utils/getclientid";
import API from "./config";

// Subscribe Form

export const postSubscribeForm = (formData) => {
  return API.post("/subscription", formData);
};

// Contact Form

export const postContactForm = (lang, formData) => {
  return API.post(`/contact/testing?lang=${lang}`, formData);
};

export const fetchConsultationServices = (lang = "en") => {
  return axiosInstance.get(`/consultation/services/${lang}`, {
    headers: {
      "x-client-id": getClientId(),
      "Accept-Language": lang, // optional, but ok
    },
  });
};

// export const postConsultationForm = (formData, lang = "en") => {
//   return axiosInstance.post(`/consultation?lang=${lang}`, formData);
// };

export const postConsultationForm = (formData, lang = "en") => {
  return axiosInstance.post(
    `/websiteform/staging/new-lead?lang=${lang}`,
    formData,
  );
};

// Get In Touch Form

export const postGetInTouchForm = (formData) => {
  return API.post("/getintouch", formData);
};

// Blog Comment Form

export const postCommentForm = (id, formData) => {
  return axiosInstance.post(`/blogs/${id}/comment`, formData);
};

// Careers API

export const fetchCareersData = (lang) => {
  return API.get(`/careers/all/careers?lang=${lang}`);
};

export const fetchCareersDetails = (slug, lang) => {
  return API.get(`/careers/slug/${slug}?lang=${lang}`);
};

// Career Apply Form

export const postApplyForm = (id, lang, formData, header) => {
  return axiosInstance.post(
    `/careers/${id}/apply?lang=${lang}`,
    formData,
    header,
  );
};

// Author API

export const fetchAuthorDetails = (
  slug,
  lang,
  { page = 1, limit = 10 } = {},
) => {
  return API.get(`/authors/profile/${encodeURIComponent(slug)}`, {
    params: { lang, page, limit },
  });
};

// Faqs API

export const fetchFaqData = (lang) => {
  return API.get(`/faqs/faq/all?lang=${lang}`);
};

// Team API

export const fetchTeamData = (lang) => {
  return API.get(`/teams/team/all?lang=${lang}`);
};

// Service Menu
export const fetchMenuServicesData = (lang) => {
  return API.get(`/service-categories/with-services?lang=${lang}`);
};

// Industries Menu

export const fetchMenuIndustriesData = (lang) => {
  return API.get(`/parentindustry/parent/tree?lang=${lang}`);
};

// Services API

export const fetchParentServicesData = (lang) => {
  return API.get(`/service-categories/with-services?lang=${lang}`);
};

export const fetchParentServicesDetails = (slug, lang) => {
  return API.get(`/parentService/slug/${slug}?lang=${lang}`);
};

export const fetchSubServicesData = () => {
  return API.get("/childService");
};
// chils service
export const fetchSubServicesDetails = (slug, lang) => {
  return API.get(`/childService/slug/${slug}?lang=${lang}`);
};

export const fetchGrandSubServicesData = () => {
  return API.get("/grandchild");
};

export const fetchGrandSubServicesDetails = (slug, lang) => {
  return API.get(`/grandchild/slug/${slug}?lang=${lang}`);
};

// Services By City

export const fetchServiceByCityData = (slug, lang) => {
  return API.get(`/servicebycountrycity/by-city-slug/${slug}?lang=${lang}`);
};

export const fetchServiceByCityDetails = (cityName, slug, lang) => {
  return API.get(
    `/servicebycountrycity/by-city-and-slug/${cityName}/${slug}?lang=${lang}`,
  );
};

// All Country/City List API

export const fetchAllCountryCityData = (lang) => {
  return API.get(`/countries/all/locations?lang=${lang}`);
};

// Client Categories API
export const fetchClientCategoriesData = (lang) => {
  return API.get(`/clients/categories?lang=${lang}`);
};

// Clients API

export const fetchClientsData = (lang, page, limit) => {
  return API.get(`/clients?lang=${lang}&page=${page}&limit=${limit}`);
};

// Filter Clients By Category API

export const fetchClientsByCategoryData = (slug, lang) => {
  return API.get(`/clients?cat=${slug}&lang=${lang}`);
};

//  Case Studies API

export const fatchHomeCaseStudies = (lang) => {
  return API.get(`/casestudy/casestudy/random?lang=${lang}`);
};

// export const fatchCaseStudies = (lang) => {
//   return API.get(`/casestudy?lang=${lang}`);
// };

export const fatchCaseStudies = (lang, page = 1, limit = 6) => {
  return API.get(`/casestudy/case/active`, { params: { lang, page, limit } });
};

export const fetchCaseStudiesDetails = (slug, lang) => {
  return API.get(`/casestudy/slug/${slug}?lang=${lang}`);
};

// Events API
export const fatchEvents = (lang, page, limit) => {
  return API.get(`/events/all/bylang?lang=${lang}&page=${page}&limit=${limit}`);
};

export const fetchEventsDetails = (slug, lang) => {
  return API.get(`/events/bylang/${slug}?lang=${lang}`);
};

//  Portfolio API

export const fatchPortfolioCategories = (lang) => {
  return API.get(`/portfolioscategories?lang=${lang}`);
};

export const fatchHomePortfolio = (lang) => {
  return API.get(`/portfolios/portfolio/home?lang=${lang}`);
};

// export const fatchPortfolio = (lang) => {
//   return API.get(`/portfolios?lang=${lang}`);
// };

export const fatchPortfolio = (lang, page = 1, limit = 6) => {
  return API.get(`/portfolios?lang=${lang}&page=${page}&limit=${limit}`);
};

export const fetchPortfolioDetails = (slug, lang) => {
  return API.get(`/portfolios/slug/${slug}?lang=${lang}`);
};

//  Industries API

export const fatchHomeIndustries = (lang) => {
  return API.get(`/parentindustry/industry/home?lang=${lang}`);
};

// export const fatchParentIndustries = (lang) => {
//   return API.get(`/parentIndustry?lang=${lang}`);
// };

export const fatchParentIndustries = (lang, page = 1, limit = 6) => {
  return API.get(`/parentIndustry`, { params: { lang, page, limit } });
};

export const fetchParentIndustriesDetails = (slug, lang) => {
  return API.get(`/parentIndustry/slug/${slug}?lang=${lang}`);
};

export const fatchChildIndustries = (lang) => {
  return API.get(`/industrychild?lang=${lang}`);
};

export const fetchChildIndustriesDetails = (slug, lang) => {
  return API.get(`/industrychild/slug/${slug}?lang=${lang}`);
};

// Blogs API

export const fetchBlogData = (params) => {
  return API.get("/blogs", { params });
};

export const fetchBlogDetails = (slug, lang) => {
  return API.get(`/blogs/slug/${slug}?lang=${lang}`);
};

// News API

export const fetchNewsData = (params) => {
  return API.get(`/news/all/active`, { params });
};

export const fetchNewsDetails = (slug, lang) => {
  return API.get(`/news/slug/${slug}?lang=${lang}`);
};

// Testimonials API

export const fetchTestimonialData = () => {
  return API.get("/testimonials?page=1&limit=10");
};

//  Pages API

export const fatchPagesContent = (route) => {
  return API.get(`/pages/${route}`);
};

//  Partners API

export const fatchPartners = () => {
  return API.get(`/partner`);
};

// All podcast categories
export const fetchPodcastCategoriesData = () => {
  return API.get(`/podcasts/categories`);
};

export const fetchPodcastsData = (cat, page = 1, limit = 10) => {
  return API.get(`/podcasts?category=${cat}&page=${page}&limit=${limit}`);
};

export const fetchPodcastBySlug = (slug) => {
  return API.get(`/podcasts/${encodeURIComponent(slug)}`);
};
